import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-list-check",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 5.5l1.5 1.5l2.5 -2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 11.5l1.5 1.5l2.5 -2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 17.5l1.5 1.5l2.5 -2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 6l9 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 12l9 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 18l9 0" })
	]
});
const ForwardRef = forwardRef(SvgListCheck);
export default ForwardRef;
